import axios from 'axios';
import auth from './auth';
import store from '../store';

let API_URL = 'https://api.escapeitkit.com:443/api/';
if (location.hostname === 'localhost') {
    API_URL = 'http://localhost:9000/api/';
}

export default {
    purchaseKit: function(kit_id, token, coupon) {
        return new Promise((resolve, reject) => {
            axios.post(API_URL + 'kits/purchase', {kit_id: kit_id, token: token, coupon: coupon}, {headers: auth.getAuthHeader()}).then(response => {
                store.commit('user/addToKits', kit_id);
                resolve(response.data);
            }, err => {
                reject(err.response.data);
            });
        });
    },

    buildKit: function(kit_id, title) {
        return new Promise((resolve, reject) => {
            axios.post(API_URL + 'kits', {kit_id: kit_id, title: title}, {headers: auth.getAuthHeader()}).then(response => {
                store.commit('user/addToBuilds', response.data);
                resolve(response.data);
            }, err => {
                reject(err.response.data);
            });
        });
    },

    getBuild: function(build_id) {
        return new Promise((resolve, reject) => {
            axios.get(API_URL + 'kits/' + build_id, {headers: auth.getAuthHeader()}).then(response => {
                resolve(response.data);
            }, err => {
                reject(err.response.data);
            });
        });
    },

    updateBuild: function(build_id, title, config) {
        return new Promise((resolve, reject) => {
            axios.put(API_URL + 'kits/' + build_id, {title: title, config: config}, {headers: auth.getAuthHeader()}).then(response => {
                resolve(response.data);
            }, err => {
                reject(err.response.data);
            });
        });
    },

    downloadBuild: function(build_id) {
        return new Promise((resolve, reject) => {
            axios.get(API_URL + 'kits/download/' + build_id, {headers: auth.getAuthHeader()}).then(response => {
                resolve(response.data);
            }, err => {
                reject(err.response.data);
            });
        });
    },

    deleteBuild: function(build_id) {
        return new Promise((resolve, reject) => {
            axios.delete(API_URL + 'kits/remove/' + build_id, {headers: auth.getAuthHeader()}).then(response => {
                store.commit('user/removeBuild', build_id);
                resolve(response.data);
            }, err => {
                reject(err.response.data);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/kits.js